<div
  role="region"
  aria-label="Sidebar Content"
  class="SmcSidebar--Desktop"
  [ngClass]="{ 'SmcSidebar__BG--Reverse': hasBackgroundChanged }"
>
  <div class="SmcSidebar__Label">
    <label
      class="SmcSidebar__LabelText"
      tabindex="0"
      aria-label="Sidebar Label"
      data-test-id="sidebarLabel"
    >
      <ng-content select="[sidebarLabel]"></ng-content>
    </label>
  </div>

  <ng-content select="[sidebarBody]"></ng-content>
</div>

<div class="SmcSidebar--Mobile">
  <ng-content select="[sidebarLabelMobile]"></ng-content>
  <ng-content select="[sidebarBodyMobile]"></ng-content>
</div>

@if (!isOverviewOpen) {
  <div
    class="SmcSidebar--Tablet"
    [ngClass]="{ 'SmcSidebar__BG--Reverse': hasBackgroundChanged }"
  >
    <icon
      name="hra"
      [config]="{ type: 'link', fill: 'primary' }"
      (click)="isOverviewOpen = !isOverviewOpen"
    ></icon>
  </div>
}

@if (isOverviewOpen) {
  <div
    class="SmcSidebar--Tablet SmcSidebar--TabletOpen"
    [ngClass]="{ 'SmcSidebar__BG--Reverse': hasBackgroundChanged }"
  >
    <section @slideLeft>
      <icon
        name="close"
        class="SmcSider--TabletIcon"
        [config]="{ type: 'pointer' }"
        (click)="isOverviewOpen = false"
      ></icon>
      <div class="SmcSidebar__Label">
        <h6 tabindex="0">
          <ng-content select="[sidebarLabelTablet]"></ng-content>
        </h6>
      </div>
      <ng-content select="[sidebarBodyTablet]"></ng-content>
    </section>
  </div>
}
